import * as React from "react";

export const PinnedRowOtherColumn: React.FunctionComponent<any> = ({ style }) => <div style={style} />;
